import { HomeTwoTone } from '@mui/icons-material';
import {
  Box,
  Breadcrumbs,
  Link as MLink,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { NavMenuList, NavMenuListSkeleton } from '../components/NavMenuList';
import PageHeader from '../components/PageHeader';
import { useAccountWithGuard } from '../hooks/api/account-with-guard';
import { useAuth } from '../hooks/useAuth';
import { useEffect } from 'react';

export function AccountPage() {
  const nav = useNavigate();
  const { setToken } = useAuth();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // ensure user logged in
  const { data, isLoading } = useAccountWithGuard();
  const handleLogout = () => {
    setToken('');
    localStorage.removeItem('id_token');
    nav('/login');
  };

  useEffect(() => {
    if (!isMobile) {
      nav('/account/orders');
    }
  });

  return (
    <Box>
      <PageHeader title={t('navMenuList.myAccountTitle')} />

      <Breadcrumbs>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <Typography>{t('accountPage.account')}</Typography>
      </Breadcrumbs>

      {isLoading ? (
        <NavMenuListSkeleton />
      ) : (
        <NavMenuList
          showArrows
          onLogout={handleLogout}
          userPermissions={data?.permissions}
          firstName={data?.individual?.firstName}
          lastName={data?.individual?.lastName}
          employee={data?.employee}
        />
      )}
    </Box>
  );
}
